import DiseaseList from './DiseaseList';

export default DiseaseList;
